<template>
  <div class="personal-center-page">
    <!-- 头部banner区域 -->
    <div class="header-banner">
      <div class="banner-content">
        <img
          src="@/assets/college/bg-banner.png"
          class="banner-image"
        />
        <!-- 页面标题 -->
        <div class="page-header">
          <h1 class="page-title">查看权益</h1>
        </div>
      </div>
      <!-- 顶部导航栏 - 覆盖在banner上 -->
      <div class="top-nav-bar">
        <van-icon name="arrow-left" class="back-icon" @click="goBack" />
        <h1 class="nav-title">查看权益</h1>
      </div>
      <div class="nav-divider"></div>
    </div>

    <!-- 金色banner卡片 -->
    <div
      class="golden-banner"
      :class="{ 'without-college-logo': collegeName[productId].showLogo === false }"
    >
      <img
        src="@/assets/college/vip-card/card.png"
        alt="卡片背景"
        class="card-background"
      />
      <!-- 原 Logo 模板保留，恢复方式见 college/config.js 的 showShandongUniversityLogo 开关。 -->
      <img
        v-if="collegeName[productId].showLogo !== false"
        :src="collegeName[productId].logoCard"
        alt="logo"
        class="logo-image"
      />
      <img
        src="@/assets/college/vip-card/vip.png"
        alt="vip"
        class="vip-image"
      />
      <img
        src="@/assets/college/vip-card/super.png"
        alt="super"
        class="super-image"
      />
      <img
        src="@/assets/college/vip-card/text.png"
        alt="text"
        class="text-image"
      />
      <!-- <div class="vip-card-text">
        <span>5年、10年</span>
      </div> -->
      
      <img v-if="yearImage" :src="yearImage" alt="year" class="year-image" />
    
    </div>

    <!-- 我的权益区域 -->
    <div class="rights-content-section">
      <h2 class="rights-title">我的权益</h2>
      <div class="divider"></div>

      <div
        v-for="(item, index) in privileges"
        :key="index"
        class="privilege-item"
      >
        <div class="privilege-header">
          <div class="privilege-icon">
            <img :src="item.icon" :alt="item.title" />
          </div>
          <div class="privilege-name">{{ item.title }}</div>
        </div>
        <div class="privilege-content">
          <div
            v-for="(point, idx) in item.points"
            :key="idx"
            class="privilege-point"
          >
            <span class="point-bullet">•</span>
            <span class="point-text">{{ point }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { college } from "../college/config";

export default {
  name: "ClientRightsDetail",
  data() {
    return {
       collegeName: college,
      productId: '0',
      privilegeName: "",
      privileges: [
        /*{
          icon: require("@/assets/client/rights_icon_1.png"),
          title: "免疫细胞存储权益",
          points: ["在液氮环境中长期保存您的免疫细胞。您拥有该份自体细胞样本的所有权、处置权、使用权。"],
        },*/
        {
          icon: require("@/assets/client/rights_icon_1.png"),
          title: "权益一：生命银行",
          points: ["免疫细胞存储, 1次"],
        },
        {
          icon: require("@/assets/client/rights_icon_2.png"),
          title: "权益二：终身特权",
          points: [
            "存储年限到期后，可享生命银行3折补贴权益，延长细胞存储时间；",
            "可不限次享受我方在北戴河，博鳌，横琴等医疗先行区内的各类先进细胞应用技术的3折补贴权益。",
          ],
        },
      ],
    };
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    this.productId = urlParams.get("productId") || localStorage.getItem("productId") || "0";
  },
  mounted() {
    // 从路由参数获取权益信息
    const query = this.$route.query;
    if (query.privilegeName) {
      this.privilegeName = query.privilegeName;
    }
  },
  computed: {
    yearImage() {
      if (!this.privilegeName) return null;
      const isTwentyYear = this.privilegeName.indexOf("二十年") > -1 || this.privilegeName.indexOf("20") > -1;
      const isTenYear =
        this.privilegeName.indexOf("十") > -1 ||
        this.privilegeName.indexOf("10") > -1;
      try {
        let year = "5";
        if (isTwentyYear) {
          year = "20";
        } else if (isTenYear) {
          year = "10";
        }
        return require(`@/assets/client/${year}_year.png`);
      } catch (error) {
        return null;
      }
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped src="../college/logo-layout.css"></style>

<style scoped lang="less">
.personal-center-page {
  min-height: 100vh;
  background: #eee;

  position: relative;
  padding-bottom: 20px;
}

/* 顶部导航栏 - 覆盖在banner上 */
.top-nav-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 200;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  height: 44px;
  box-sizing: border-box;
}

.back-icon {
  position: absolute;
  left: 16px;
  font-size: 20px;
  color: #333;
  cursor: pointer;
  z-index: 1;
}

.nav-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.nav-divider {
  position: absolute;
  top: 44px;
  left: 0;
  right: 0;
  height: 1px;
  background: #1890ff;
  z-index: 199;
}

/* 头部banner区域 */
.header-banner {
  position: relative;
  height: 245px;
  overflow: hidden;
}

.banner-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.banner-content {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  align-items: center;
}

/* 页面标题 */
.page-header {
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
  z-index: 3;
  text-align: center;
}

.page-title {
  color: white;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

/* 金色banner卡片 */
.golden-banner {
  position: relative;
  z-index: 2;
  padding: 0 20px 20px;
  margin-top: -160px;
}

.card-background {
  width: 100%;
  height: auto;
  display: block;
}

.logo-image {
  position: absolute;
  width: 200px;
  left: 40px;
  top: 20px;
}

.text-image {
  position: absolute;
  width: 280px;
  left: 40px;
  top: 80px;
}

.super-image {
  position: absolute;
  width: 50px;
  left: 40px;
  top: 115px;
}
.year-image {
  position: absolute;
  right: 40px;
  top: 130px;
  width: 70px;
  height: auto;
}

.vip-image {
  position: absolute;
  width: 30px;
  left: 95px;
  top: 111px;
}

.vip-card-text {
  position: absolute;
  right: 40px;
  top: 145px;
  padding: 7px 10px;
  border-radius: 3px;
  background: linear-gradient(
    268deg,
    rgba(245, 196, 133, 1) 0.61%,
    rgba(254, 221, 189, 1) 97.34%
  );
  color: rgb(126, 86, 33);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
}

/* 我的权益区域 */
.rights-content-section {
  background: white;
  border-radius: 16px 16px 0 0;
  padding: 20px 16px 40px;
  margin-top: -10px;
  position: relative;
  z-index: 1;
  margin-left: 20px;
  margin-right: 20px;
}

.rights-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin: 0 0 12px 0;
}

.divider {
  height: 1px;
  background: #e5e5e5;
  margin-bottom: 20px;
}

.privilege-item {
  margin-bottom: 24px;
}

.privilege-item:last-child {
  margin-bottom: 0;
}

.privilege-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.privilege-icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: linear-gradient(
    -45.14deg,
    rgba(240, 137, 62, 1) -1.9%,
    rgba(245, 203, 112, 1) 101.25%
  );
  border-radius: 50%;
  color: white;
  img {
    width: 20px;
    height: 20px;
  }
}

.privilege-name {
  font-size: 16px;
  font-weight: bold;
  color: #a16222;
}

.privilege-content {
  padding: 0 34px;
}

.privilege-point {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  line-height: 1.6;
}

.privilege-point:last-child {
  margin-bottom: 0;
}

.point-bullet {
  color: #1890ff;
  font-size: 20px;
  font-weight: bold;
  margin-right: 8px;
  flex-shrink: 0;
  line-height: 1;
}

.point-text {
  font-size: 14px;
  color: #4f4f4f;
  flex: 1;
  line-height: 1.6;
}
</style>
